// extracted by mini-css-extract-plugin
export var pillWrapper = "_ye-0";
export var showOverflow = "_ye-1";